import { Stack, Label, IStackTokens } from '@fluentui/react';
import React, { useContext } from 'react';
import styles from '../../styles/pokemon.module.scss';
import { TProduct, TSize } from '../../constants/types';
import GlobalContext from '../../_contexts/GlobalContext';
import Product from './productComponent';

export interface IproductenComponentProps {
    satprice: number;
    eurprice: number;
    windowSize: TSize;
    onImageClick: Function;
    isdev: boolean;
    onBuyClick: Function;
    products : TProduct[];
    showMinimize?: boolean;
    SetSelectedProductForAlert?: Function;
    AlertCoachmarkVisible: boolean;
}

const Producten : React.FunctionComponent<IproductenComponentProps> = (props : IproductenComponentProps) => {
    const productTokens: IStackTokens = {
        childrenGap: 10,
        padding: 5
    };

    const { Strings } = useContext(GlobalContext);

    return (   
        <Stack className={styles.mainSection}>
            <Stack horizontal style={{width:"100%", cursor:props.showMinimize?"pointer":"cursor"}}>
                <Stack horizontal className={styles.boosterLabelMain}>
                    <Label className={styles.boosterLabel}>{Strings?.Related}</Label>
                </Stack>
            </Stack> 
            {props.products.length   && <Stack horizontal wrap tokens={productTokens} horizontalAlign='start' key={props.products.length ? props.products[0].id : 1}>
                                                {props.products.map(product => {
                                                    return  <div style={{maxWidth:props.windowSize.x < 960 ? 430 : ""}}>
                                                                <Product hideSwipe={props.windowSize.x < 800 ? false : true} 
                                                                    SetSelectedProductForAlert={props.SetSelectedProductForAlert}
                                                                    AlertCoachmarkVisible={props.AlertCoachmarkVisible}
                                                                    onBuyClick={props.onBuyClick} 
                                                                    imageSize={{x: props.windowSize.x <= 960 ? 280 : 430, y: props.windowSize.x <= 960 ? 220 : 500}} 
                                                                    eurprice={props.eurprice} 
                                                                    satprice={props.satprice}
                                                                    onImageClick={props.onImageClick} 
                                                                    product={product} />
                                                            </div>
                                                })}
                                            </Stack>}
                                
        </Stack>
    );
}

export default Producten;